import type { DashboardLibraryState } from '@highimpact/dashboard-types';
import { useCallback } from 'react';

import { hydrateDashboardLibraryState } from '../state/actions';
import type { DashboardRuntimeDispatch } from '../state/dashboardRuntimeTypes';
import { useDashboardLibraryDispatch } from './DashboardLibraryProvider';
import { dashboardRuntimeReducer } from './dashboardRuntimeReducer';

/** Maps widget runtime actions onto the isolated dashboard library store. */
export function useDashboardRuntimeDispatchAdapter(): DashboardRuntimeDispatch {
  const libDispatch = useDashboardLibraryDispatch();
  return useCallback<DashboardRuntimeDispatch>(
    (action) => {
      libDispatch((dispatch, getState) => {
        const current = getState() as DashboardLibraryState;
        if (action.type === 'hydrate') {
          dispatch(
            hydrateDashboardLibraryState({
              ...current,
              dashboard: action.payload,
            })
          );
          return;
        }

        const nextDashboard = dashboardRuntimeReducer(
          current.dashboard,
          action
        );
        dispatch(
          hydrateDashboardLibraryState({
            ...current,
            dashboard: nextDashboard,
          })
        );
      });
    },
    [libDispatch]
  );
}
